import { UploadTagStats } from './UploadTagStats';
import { UserUpload, exampleUserUpload } from './UserUpload';

export interface UserUploadWithStats extends UserUpload {
  stats?: UploadStats;
  status: UploadStatStatus;
}

export interface UploadStats
  extends Pick<UploadTagStats, 'countNew' | 'countRepeat' | 'value'> {
  uploaded: string | number; // 23 / 100 | 100 | N/A
  matchRate: string; // N/A | pending | x%
}

export type UploadStatStatus =
  | 'pending'
  | 'processing'
  | 'benchmarked'
  | 'attributed'
  | 'uploaded';

export const exampleUserUploadWithNoStats: UserUploadWithStats = {
  ...exampleUserUpload,
  status: 'pending',
};

export const exampleUserUploadWithStats: UserUploadWithStats = {
  ...exampleUserUpload,
  status: 'attributed',
  stats: {
    countNew: 4,
    countRepeat: 6,
    value: 10,
    uploaded: '5 / 10',
    matchRate: '50.00%',
  },
};
